import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useAuthPopup } from '../hooks/useAuthPopup';
import TokenIcon from './TokenIcon';

// Web app signup via Auth0 Universal Login popup. Social (Google) + email options.
// Same popup flow the homepage buttons use — this page is just the /register
// landing for direct links; the popup itself is owned by useAuthPopup.
const RegisterPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const { openAuthPopup, isLoading, error } = useAuthPopup();

  // If already logged in, redirect to profile
  useEffect(() => {
    if (!authLoading && isAuthenticated) {
      navigate('/profile');
    }
  }, [isAuthenticated, authLoading, navigate]);

  const handlePopupSignup = () => openAuthPopup('signup');

  return (
    <div className="max-w-md mx-auto mt-10">
      <div className="text-center mb-8">
        <div className="flex justify-center mb-3"><TokenIcon size={72} flat={false} /></div>
        <h1 className="text-4xl font-bold text-white">Create your account</h1>
        <p className="text-wp-muted mt-2">One balance. Every paywall.</p>
      </div>

      <div className="bg-wp-surface rounded-2xl p-8 space-y-4">
        <button
          onClick={handlePopupSignup}
          disabled={isLoading}
          className="w-full bg-wp-accent text-wp-bg font-bold py-3 rounded-xl hover:opacity-80 transition-opacity disabled:opacity-50 flex items-center justify-center gap-2"
        >
          {isLoading ? (
            <>
              <span className="inline-block w-4 h-4 border-2 border-wp-bg border-t-transparent rounded-full animate-spin"></span>
              Continue in the popup…
            </>
          ) : (
            'Sign up with Google or Email'
          )}
        </button>

        {error && <p className="text-wp-danger text-sm text-center">{error}</p>}

        <p className="text-center text-sm text-wp-muted">
          Already have an account?{' '}
          <Link to="/login" className="font-semibold text-wp-accent hover:opacity-80">Log in</Link>.
        </p>
      </div>
    </div>
  );
};

export default RegisterPage;
